import React from "react"
import styled, { css } from "styled-components"
import {
  Input as BaseInput,
  type InputProps as BaseInputProps,
} from "~/ur-react-components"

interface StyledInputProps {
  hasError?: boolean
  hasWarning?: boolean
}

const StyledInput = styled(BaseInput)<StyledInputProps>`
  input {
    border: 1px solid;
    border-color: ${(props) => props.theme.colors.gray70};
    border-radius: 4px;
    padding-left: 1rem;

    :focus {
      border: 2px solid;
      border-color: ${(props) => props.theme.colors.primary40};
    }
  }

  .--input-icon-right {
    border: none;
    color: ${(props) => props.theme.colors.gray50};
    width: 1.5rem !important;
    min-width: 1.5rem !important;
    justify-content: end;
  }

  ${(props) =>
    props.hasError &&
    css`
      input {
        border-color: ${props.theme.colors.error40} !important;
      }
    `}

  ${(props) =>
    props.hasWarning &&
    css`
      input {
        border-color: ${props.theme.colors.warning40} !important;
      }
    `}

  [disabled] {
    background: ${(props) => props.theme.colors.gray90};
    color: ${(props) => props.theme.colors.gray70};
    border: 1px solid ${(props) => props.theme.colors.gray70};
    cursor: not-allowed;
  }
`

const Error = styled.div`
  color: ${(props) => props.theme.colors.error40};
  font-size: 12px;
  margin-top: 8px;
  margin-left: 4px;
`

const Warning = styled.div`
  color: ${(props) => props.theme.colors.warning40};
  font-size: 12px;
  margin-top: 8px;
  margin-left: 4px;

  position: absolute;
`

export interface InputProps extends BaseInputProps {
  warning?: string | null
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { height = "48px", borderRadius = "4px", error, warning, ...props },
    ref,
  ) => {
    return (
      <>
        <StyledInput
          ref={ref}
          height={height}
          borderRadius={borderRadius}
          hasError={!!error}
          hasWarning={!!warning}
          {...props}
        />
        {error && <Error>{error}</Error>}
        {warning && <Warning>{warning}</Warning>}
      </>
    )
  },
)
